<template>
    <b-modal
        :visible="true"
        no-close-on-esc
        no-close-on-backdrop
        no-fade
        hide-footer
        hide-header
        modal-class="saveUserSearchModal"
    >
        <!-- Header -->
        <div class="panel-header">
            <h3 class="panel-header-title">
                {{ $t('userSearches.save') }}
            </h3>
            <!-- Close icon -->
            <icon-close
                SMT-NG-CLOSE_SAVE_USERSEARCH
                @close="$_onClose"
                class="d-inline-block float-right"
            />
        </div>
        <!-- Content -->
        <div class="content">
            <b-form v-on:submit.prevent="$_onSubmit">
                <x-input
                    name="saveUserSearchName"
                    :text="$t('userSearches.name')"
                    v-model="name"
                    maxlength="50"
                    :required="true"
                />

                <!-- Buttons -->
                <div class="buttons">
                    <b-button variant="primary" type="submit">
                        {{ $t('btnSaveLabel') }}
                        <span class="far" />
                    </b-button>
                    <b-button @click="$_onClose">
                        {{ $t('btnCancelLabel') }}
                    </b-button>
                </div>
            </b-form>
        </div>
    </b-modal>
</template>

<script>
    import IconClose from '../../../IconClose.vue';
    export default {
        components: { 'icon-close': IconClose },
        props: { defaultName: { type: String, required: false, default: '' } },
        data() {
            return { name: this.defaultName };
        },
        methods: {
            $_onClose() {
                this.$emit('close');
            },

            $_onSubmit() {
                this.$emit('create', this.name);
            }
        }
    };
</script>

<style lang="scss">
.saveUserSearchModal .modal-dialog {
    position: absolute;
    margin: 0px;
    top: 15%;
    left: calc(50% - 215px);
    min-height: 40px;
    min-width: 430px;
    max-width: 430px;

    & .modal-content {
        height: 100%;
        border: none;
        border-radius: initial;
    }
}

.saveUserSearchModal .modal-body {
    padding: 0px;
    height: 100%;
}

@media (max-width: 767px) {
    .saveUserSearchModal .modal-dialog {
        top: 0 !important;
        left: 0;
        bottom: 0 !important;
        right: 0;
        min-width: 0;
        max-width: none;
    }
}
</style>

<style scoped lang="scss">
.info {
    padding: 20px 20px 0px 20px;

    & p {
        margin-bottom: 0;
    }
}

.content {
    display: flex !important;
    flex-direction: column;
    overflow-y: auto;
    padding: 20px;
    flex: 1;
}

.buttons {
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;

    & > button:first-child {
        margin-right: 3px;
    }
}
</style>
